import { css } from 'linaria';
import { mobile } from 'style/mixins';
export const works = "wv4vksl";
export const center = "c1dns40h";
export const work = "wa3y397";
export const posterWrapper = "piocxyg";
export const poster = "po8uucz";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/works/styles.linaria.css");